define("shared/utils/object-methods/object-filter", ["exports", "lodash"], function (_exports, _lodash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"lodash"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class objectFilter
   * @extends Utils
   */
  /**
   * Filter through object entries and apply given callback to
   * the entries returning the modified object
   *
   * @method objectFilter
   * @param {Object} obj Object to be filtered
   * @param {Function} callback Callback to be called for every filter iteration
   *
   * @return {Object} Filtered object
   */
  const objectFilter = (obj, callback) => (0, _lodash.fromPairs)(Object.entries(obj || {}).filter(callback));
  var _default = _exports.default = objectFilter;
});